export enum AppActionTypes {
  MOUNT_SNACKBAR = "MOUNT_SNACKBAR",
  UNMOUNT_SNACKBAR = "UNMOUNT_SNACKBAR",
}
